import { render, staticRenderFns } from "./SideBarBooking.vue?vue&type=template&id=fa031d72&"
import script from "./SideBarBooking.vue?vue&type=script&lang=js&"
export * from "./SideBarBooking.vue?vue&type=script&lang=js&"
import style0 from "./SideBarBooking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports